import Button from "@/common/components/Button";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useNavigate, useParams } from "react-router-dom";

const DirectiveEntryDiagnosticEntryInProgress = () => {
  const { id: workflowId } = useParams();

  const { forwarding } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry
  >();

  const navigate = useNavigate();

  const isDiagnosticEntryDisapproved = forwarding.directive_entry?.last_review?.state === 'disapproved';

  return (
    <Button
      onClick={() => navigate(`/maintenance-workflows/${workflowId}/diagnostic-entry/${forwarding.id}`)}
      operationKlassToCheckPermission="Establishment::Maintenance::Directive::DiagnosticEntries::Update"
    >
      {isDiagnosticEntryDisapproved
        ? 'Revisar Diagnóstico e Orçamento'
        : 'Continuar Diagnóstico e Orçamento'}
    </Button>
  );
}

export default DirectiveEntryDiagnosticEntryInProgress;
